export default function translate(i18n, propriete) {
  if (propriete === 'montantAnnuelHt') {
    return i18n.t('ajoutEditContrat.echeancier.popUpCreation.montantAnnuelleHt');
  }
  if (propriete === 'dateFin') {
    return i18n.t('ajoutEditContrat.echeancier.popUpCreation.messages.error.dateFinRequire');
  }
  if (propriete === 'dateDebut') {
    return i18n.t('ajoutEditContrat.echeancier.popUpCreation.messages.error.dateDebutRequire');
  }
  if (propriete === 'quantitePeriodicite') {
    return i18n.t('ajoutEditContrat.echeancier.popUpCreation.messages.error.peiodiciteRequire');
  }
  if (propriete === 'montantAnnuelHt') {
    return i18n.t('ajoutEditContrat.echeancier.popUpCreation.messages.error.montantAnuelleRequired');
  }
  return propriete;
}
